<template>
    <TxProductAdminPortal>
        <TxRendererQuery/>
        <TxRendererStatus/>
        <div v-if="data.url">
            <img class="preview-image" :src="data.fullUrl" :key="data.fullUrl">
        </div>
        <div v-if="pdf.fullUrlPdf">
            <a ref="pdfLink" target="_blank" :href="pdf.fullUrlPdf">fullUrlPdf</a>
        </div>
        <div class="buttons">
            <button class="lovemap-admin-button"
                    :class="[{loading: saveLoading}]"
                    @click.prevent="savePDF"
                    v-if="data.url"
            >
                Save PDF
            </button>
            <button class="lovemap-admin-button" :class="[{loading: previewLoading}]" @click.prevent="previewPDF">
                Preview PDF
            </button>
            <button class="lovemap-admin-button" :class="[{loading: previewLoading || saveLoading}]"
                    @click.prevent="fullPDF">full cycle
            </button>
        </div>
        <div>
            <div>
                Manual Quality: <input v-model.number="pixelRatio"><br>
                Min: 1; Max: 10
            </div>
        </div>
        <hr>
        <h3>Reminder: at the highest quality scores there is a greater chance of incorrect display</h3>
        <hr>
        <TxRenderedPdfs/>
        <TxToSaveParams :to-save-params="toSaveParams"/>
    </TxProductAdminPortal>
</template>

<script>
    import PosterTextModule from "@packages/tx-products/products/poster-text/store-mixin";

    export default {
        name: "PosterTextAdmin",
        mixins: [PosterTextModule()],
        data() {
            return {
                previewLoading: false,
                saveLoading: false,
                pixelRatio: 4,
                data: {},
                pdf: {},
            }
        },
        watch: {
            pixelRatio(newValue, oldValue) {
                if (!newValue || newValue < 1) {
                    this.pixelRatio = 1
                }
                if (newValue > 10) {
                    this.pixelRatio = 10
                }
            }
        },
        methods: {
            async previewPDF() {
                this.previewLoading = true
                let data = {
                    pixelRatio: this.pixelRatio,
                    mapData: this.toSaveParams,
                    orderID: this.order_id,
                    ID: this.ID
                };

                let {data: serverData} = await this.$http({
                    method: 'POST',
                    url: `${lovemap.config.render_url}/api/pdf-render/preview`,
                    data,
                });
                // let serverData = { "url": "https://ub.md.ukrosoft.com.ua/wp-content/uploads/2019/08/eewk2tjzlcpkxb.png" }

                this.data = serverData;
                this.pdf = false;
                this.previewLoading = false;
            },
            async savePDF() {
                this.saveLoading = true;
                let mapData = {
                    mapData: this.toSaveParams,
                    pixelRatio: this.pixelRatio,
                    orderID: this.order_id,
                    ID: this.ID,
                    manual: true,
                };
                const {data} = await this.$http({
                    // responseType: 'blob',
                    method: 'POST',
                    url: `${lovemap.config.render_url}/api/pdf-render/pdf`,
                    data: {
                        ...mapData,
                        ...this.data,
                    },
                });
                console.log(data);
                this.pdf = data;
                this.saveLoading = false;
                this.$nextTick(() => {
                    console.log(this.$refs.pdfLink);
                    this.$refs.pdfLink.click();
                })
            },
            async fullPDF() {
                this.data = {};
                this.pdf = {};
                await this.previewPDF();
                await this.savePDF();
            }
        },
        computed: {
            config() {
                return lovemap.config
            },
            order_id() {
                return order_id
            },
            ID() {
                return ID
            }
        }

    }
</script>

<style lang="scss">
    #lm_lovemap_product_form_view {
        min-height: 100vh;
    }
</style>

<style lang="scss" scoped>
    .preview-image {
        max-width: 50%;
        border: 1px dashed #ccc;
    }

    .buttons {
        margin: 15px 0 15px 15px;
        text-align: right;

        .lovemap-admin-button {
            cursor: pointer;
            outline: 0;
            border: none;
            text-align: center;
            text-transform: uppercase;
            -webkit-box-shadow: none;
            width: 100%;
            min-width: 80px;
            max-width: 180px;
            -o-transition: all 0.3s;
            transition: all 0.3s;
            -webkit-transition: all 0.3s;
            background-color: #EC7A5C;
            margin: 0 0 0 20px;
            position: relative;
            text-decoration: none;
            overflow: visible;
            padding: 10px;
            border-radius: 3px;
            left: auto;
            border: 0;
            display: inline-block;
            box-shadow: none;
            text-shadow: none;
            color: #fff;
            -webkit-font-smoothing: antialiased;
            border: none;
            font-size: 18px;
            font-weight: bold;
            line-height: 1.4em;
            font-smoothing: antialiased;
            -webkit-font-smoothing: antialiased;
            -moz-font-smoothing: antialiased;

            &.loading {
                background-color: gray;
                cursor: wait;
            }
        }
    }
</style>